import { render, staticRenderFns } from "./IconFilePdf.vue?vue&type=template&id=3d7e82b6&"
import script from "./IconFilePdf.vue?vue&type=script&lang=ts&"
export * from "./IconFilePdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports